var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAbcActive = function SvgAbcActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 26
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#115AA7",
    stroke: "#115AA7",
    strokeDasharray: "0,0",
    d: "M0 0h19a8 8 0 0 1 8 8v18L13.5 13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M16.465 11.535a.71.71 0 0 0 1.007 0l4.32-4.319a.713.713 0 0 0-1.008-1.007l-3.846 3.784-1.722-1.721A.713.713 0 1 0 14.21 9.28z"
  }))));
};
export default SvgAbcActive;